/**
 * Compara dois valores e retorna `true` se forem diferentes.
 *
 * @param {*} x - Valor atual.
 * @param {*} y - Valor de comparação.
 * @returns {boolean} `true` se `x != y`, senão `false`.
 */
export function different(x, y) {
  return x != y;
}
